<template>
    <div>
        <TabButtons :buttons="tab_buttons" :active_button="active_panel" :panel-changed-method="panelChanged" />
        <CreateAdtechUser v-show="active_panel == 'create_adtech_user'"/>
        <CreateTestUser v-show="active_panel == 'create_test_user'"/>
    </div>
</template>

<script>
import TabButtons from '@/components/TabButtons.vue';
import CreateTestUser from '../Create/CreateTestUser.vue';
import CreateAdtechUser from '../Create/CreateAdtechUser.vue';

export default {
    name: "CreateUser",
    components: {
        TabButtons,
        CreateTestUser,
        CreateAdtechUser
    },
    props: {},
    data() {
        return {
            active_panel: 'create_adtech_user',
            tab_buttons: [
                {
                    name: 'create_adtech_user',
                    text: 'Create Adtech User'
                },
                {
                    name: 'create_test_user',
                    text: 'Create Roblox Test User'
                }
            ],
        }
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    methods: {
        panelChanged(panel) {
            this.active_panel = panel
        },
    }
}
</script>

<style scoped>

</style>